import logo200Image from "../../assets/img/logo/nepal.png";
import sidebarBgImage from "../../assets/img/sidebar/sagarmatha.jpg";
import React from "react";
import bn from "../../utils/bemnames";
import { MdPerson, MdPeople } from "react-icons/md";
import {
  GiGreenhouse,
  GiHealthNormal,
  GiSyringe,
  GiAchievement,
  GiFamilyHouse,
} from "react-icons/gi";
import { IoIosPeople } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { Nav, Navbar, NavItem, NavLink as BSNavLink } from "reactstrap";
const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};
const navItems = [
  // { to: '/pariwarnirdeshika', name: 'Family Directory', exact: true, Icon: MdPerson },
  // { to: '/pariwarikjankari', name: 'Family Details', exact: true, Icon: GiFamilyHouse },
  // { to: '/jansankhya', name: 'Population Details', exact: true, Icon: IoIosPeople },
  // { to: '/ghareludata', name: 'घरेलु जानकारी', exact: true, Icon: GiGreenhouse },
  // { to: '/swasthya', name: 'स्वास्थ्य जानकारी', exact: true, Icon: GiHealthNormal },
  // { to: '/khopjankari', name: 'खोपको जानकारी', exact: true, Icon:GiSyringe },
  {
    to: "/achivements",
    name: "Employment Achievements",
    exact: true,
    Icon: GiAchievement,
  },
];
const bem = bn.create("sidebar");
class Sidebar extends React.Component {
  state = {
    isOpenComponents: false,
    isOpenContents: false,
    isOpenPages: false,
    isOpenVaccination: false,
  };
  handleClick = (name) => () => {
    this.setState((prevState) => {
      const isOpen = prevState[`isOpen${name}`];
      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  render() {
    return (
      <aside className={bem.b()} data-image={sidebarBgImage}>
        <div className={bem.e("background")} style={sidebarBackground} />
        <div className={bem.e("content")}>
          <Navbar>
            <div className="navbar-brand d-flex">
              <img
                src={logo200Image}
                width="40"
                height="30"
                className="pr-2"
                alt=""
              />
              <span className="text-white">Health Directory</span>
            </div>
          </Navbar>
          <Nav vertical>
            {navItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e("nav-item")}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  style={{ fontSize: "14px" }}
                  // className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e("nav-item-icon")} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </aside>
    );
  }
}
export default Sidebar;
